export default __webpack_public_path__ + "static/media/UpSchoolSVG.3020d99e.svg";